//@ts-check
import { View } from '@adobe/react-spectrum';
import Document from '@spectrum-icons/workflow/Document';
import React from 'react';
import { GridList } from 'react-aria-components';
import { useParams } from 'react-router-dom';

import { DetailsSectionView } from '@exchange-frontends/components';

import useGetInternalDocument from '~/actions/utilApi/selectors/useGetInternalDocument';

import { DetailHeading } from '../../../../../components/DetailHeading';
import HelpSupportGridListItem from './HelpSupportGridListItem';

/**
 * @param {object} props
 * @param {import('@action-types/ecApp').SolutionMedia} props.solutionMedia
 * @param {string} [props.title='Documentation']
 */
const SlnSideBarDocuments = ({ solutionMedia, title = 'Documentation' }) => {
  const { id } = useParams();
  const { mutate: getInternalDocument } = useGetInternalDocument({ appId: id, appType: 'SLN' });

  const items = [
    { name: 'Solution architecture diagram', data: solutionMedia?.solutionArchitectureDiagram },
    { name: 'Solution case study', data: solutionMedia?.solutionCaseStudy },
    { name: 'Solution one-pager', data: solutionMedia?.solutionOnepager },
    { name: 'Solution client presentation', data: solutionMedia?.solutionClientPresentation },
  ]
    .filter((item) => item.data?.url)
    .sort((a, b) => a.data?.order - b?.data?.order);

  if (!items.length) {
    return null;
  }

  /** @param {import('@action-types/ecApp').SolutionMediaItem} data */
  const handleClick = (data) => {
    if (/^(https?:\/\/)/.test(data.url)) {
      window.open(data.url, '_blank', 'noopener,noreferrer');
    } else {
      getInternalDocument({ uri: data.url });
    }
  };

  return (
    <View marginBottom="size-400">
      <DetailHeading level={4}>{title}</DetailHeading>
      <DetailsSectionView padding="size-0">
        <GridList aria-label="help and support" selectionMode="multiple">
          {items.map((item) => (
            <HelpSupportGridListItem
              key={item.data?.url}
              icon={<Document size="S" />}
              label={item.name}
              dataLaunchId={`${title}: ${item.name}`}
              onClick={() => handleClick(item.data)}
            />
          ))}
        </GridList>
      </DetailsSectionView>
    </View>
  );
};

export default SlnSideBarDocuments;
